import React from 'react';

export default function IndicadoresNaoAlimentadosPage() {
  return (
    <div>
      Qualidade - Indicadores Não Alimentados (placeholder).
    </div>
  );
}

